import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
export default class PlayerNoteInfoComponent extends Component {
  @tracked element;

  @action
  checkOverflow(e) {
    let element = e?.target || this.element;
    if (!element) {
      return;
    }
    if (element.scrollHeight > element.getBoundingClientRect().height) {
      element.classList.add('has-vertical-overflow');
    } else {
      element.classList.remove('has-vertical-overflow');
    }
  }

  @action
  didInsert(element) {
    this.element = element;
  }
}
